export const InputStyle = {
  baseStyle: {
    field: {
      background: 'transparent',
      borderColor: 'GRAY',
      borderWidth: '1px',
      //   borderRadius: '0px' does not affect anything - look deeper
      ':hover': {
        borderColor: 'GRAY_2',
      },
      ':focus': {
        borderColor: 'ORANGE',
        borderWidth: '2px',
      },
    },
  },
  sizes: {},
  variants: {},
  defaultProps: {
    variant: null,
  },
};

export const SelectStyle = {
  baseStyle: {
    field: {
      background: 'transparent',
      borderColor: 'GRAY',
      borderWidth: '1px',
      //   borderRadius: '0px' does not affect anything - look deeper
      ':hover': {
        borderColor: 'GRAY_2',
      },
      ':focus': {
        borderColor: 'ORANGE',
        borderWidth: '2px',
      },
    },
  },
  sizes: {},
  variants: {},
  defaultProps: {
    variant: null,
  },
};

export const RadioStyle = {
  baseStyle: {
    field: {
      background: 'transparent',
      borderColor: 'GRAY',
      borderWidth: '1px',
      focusBorderColor: 'ORANGE',
      ':hover': {
        borderColor: 'GRAY_2',
      },
      ':focus': {
        borderColor: 'ORANGE',
        borderWidth: '2px',
      },
    },
  },
  sizes: {},
  variants: {
    rsradio: {
      focusBorderColor: 'ORANGE',
      background: 'transparent',
      borderColor: 'GRAY',
      borderWidth: '1px',
      ':focus': {
        borderColor: 'ORANGE',
        borderWidth: '2px',
      },
    },
  },
  defaultProps: {
    colorScheme: 'orangeScheme',
    iconColor: 'WHITE',
    color: 'BLACK',
    borderColor: 'GRAY',
    paddingTop: 8,
    size: 'lg',
    focusBorderColor: 'ORANGE',
    ':focus': {
      borderColor: 'ORANGE',
      borderWidth: '3px',
    },
  },
};
